import DomUtil from '../../../../core/util/dom_util';
import { UserReviewRefineSearchAction } from "../../../actions/user_review_refine_search_action/user_review_refine_search_action";
import { UserReviewRefineSearch } from "../../../models/user_review_refine_search/user_review_refine_search";

// 画面更新要素リスト
const updateAreaSelectors = [
  // 商品別レビュー一覧エリア
  "#userReviewList", 
  // レビュートップパーツ
  "#review-top", 
];

export class UserReviewRefineSearchContainer {
  constructor() {
    UserReviewRefineSearchAction.UPDATE_EVENT.on(this.refreshDOMAndCallInitScripts.bind(this));
  }

  private refreshDOMAndCallInitScripts(model: UserReviewRefineSearch) {
    const newHtml = model.getModel().htmlForRender!; // newHtmlは非Null

    DomUtil.replace(
      newHtml,
      updateAreaSelectors.filter(id => document.querySelector(id)), 
      {
        reInitAll: true,
        // レビュートップへスクロール
        scrollIntoAnchorSelector: '#review-top'
      }
    );

    // スピンを非表示
    model.hideLoadingSpinner();
  }
}
